import MaterialTab, { TabProps as MTabProps, TabTypeMap } from '@mui/material/Tab'
import MaterialTabs, { TabsProps } from '@mui/material/Tabs'
import React from 'react'
import Tooltip from '#/components/Tooltip'
import cn from '#/utils/classnames'
import styles from './styles.module.scss'

export type TabProps<
  D extends React.ElementType = TabTypeMap['defaultComponent'],
  P = {}
> = MTabProps<D, P> & {
  tooltip?: string
}

export default function Tabs({
  value,
  children,
  className,
  onChange
}: TabsProps) {
  return (
    <MaterialTabs
      classes={{
        root: cn(styles['th-tabs'], className),
        indicator: styles['th-tabs-indicator']
      }}
      scrollButtons='auto'
      value={value}
      variant='scrollable'
      onChange={onChange}
    >
      {children}
    </MaterialTabs>
  )
}

Tabs.Tab = function (props: TabProps) {
  return (
    <Tooltip placement='top' tooltip={props.tooltip} trigger='hover'>
      <MaterialTab
        classes={{
          root: styles['th-tab'],
          selected: styles['th-tab-selected'],
          iconWrapper: styles['th-tab-icon']
        }}
        {...props}
      />
    </Tooltip>
  )
}
